import type {
  ListOrderOptions,
  ListSortOptions,
} from '@/modules/chatting/types'

export const listSortOptions: { label: string; value: ListSortOptions }[] = [
  { label: 'Recent', value: 'recent' },
  { label: 'Name', value: 'name' },
  { label: 'People', value: 'people' },
  { label: 'Custom', value: 'custom' },
]

export const listOrderOptions: {
  label: string
  value: ListOrderOptions
  disabled?: boolean
}[] = [
  { label: 'Ascending', value: 'asc' },
  { label: 'Descending', value: 'desc' },
]
